import { render, staticRenderFns } from "./WarehouseSupplierSendPanel.vue?vue&type=template&id=45138cba&scoped=true"
import script from "./WarehouseSupplierSendPanel.vue?vue&type=script&lang=js"
export * from "./WarehouseSupplierSendPanel.vue?vue&type=script&lang=js"
import style0 from "./WarehouseSupplierSendPanel.vue?vue&type=style&index=0&id=45138cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45138cba",
  null
  
)

export default component.exports